import { render, staticRenderFns } from "./ReArrangeStatusOrder.vue?vue&type=template&id=1624c5b3"
import script from "./ReArrangeStatusOrder.vue?vue&type=script&lang=js"
export * from "./ReArrangeStatusOrder.vue?vue&type=script&lang=js"
import style0 from "./ReArrangeStatusOrder.vue?vue&type=style&index=0&id=1624c5b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports